import React from 'react';
import {
    HeroContainer,
    BodyContainer
} from '../StyledComponents/StyledComponents';
import styled from 'styled-components';

const HeroImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    background: #d3d1ca;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        min-height: 100vh;
        height: auto;
        padding: 20px 0;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        min-height: 100vh;
        height: auto;
        padding: 15px 0;
    }
`;

const AuthorName = styled.div`
    background: white;
    padding: 4px 10px;
    margin-bottom: 0;
    cursor: pointer;
    transition: ${props => props.theme.transition};
    color: ${props => props.theme.body.headers};
    font-family: 'Playfair Display', serif;
    font-weight: 700;
    letter-spacing: -0.5px;
    white-space: nowrap;
    
    &:hover {
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.98);
    }
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        margin-bottom: 0;
        padding: 3px 8px;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        margin-bottom: 0;
        padding: 2px 6px;
    }
`;

const ImageWithText = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        flex-direction: column;
        align-items: center;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        flex-direction: column;
        align-items: center;
    }
`;

const ImageContainer = styled.div`
    background: white;
    padding: 10px 10px 5px 10px;
`;

const VerticalText = styled.div`
    background: white;
    padding: 4px 8px;
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%) translateX(46%) rotate(-90deg);
    transform-origin: center center;
    color: ${props => props.theme.body.text};
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 1px;
    white-space: nowrap;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        font-size: 16px;
        padding: 3px 6px;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        font-size: 14px;
        padding: 2px 5px;
    }
`;

const HeroImage = styled.img`
    width: 400px;
    height: auto;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        width: 300px;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        width: 250px;
    }
`;

const TextContainer = styled.div`
    background: white;
    padding: 4px 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    left: 100%;
    margin-left: 0;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        position: static;
        margin-left: 0;
        margin-top: 0;
        padding: 8px 12px;
        align-self: center;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        position: static;
        margin-left: 0;
        margin-top: 0;
        padding: 6px 10px;
        align-self: center;
    }
`;

const BlogTitle = styled.h1`
    font-family: 'Playfair Display', serif;
    font-size: 3rem;
    color: #333;
    margin: 0;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    
    @media (max-width: ${props => props.theme.queries.tablet}) {
        font-size: 2.5rem;
    }
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        font-size: 2rem;
    }
`;

const HomeHero = () => {
    return(
        <HeroContainer
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 1.5, delay: 0.3 }}
            exit={{ opacity: 0 }}
        >
            <HeroImageContainer>
                <AuthorName>Anthony Cazares</AuthorName>
                <ImageWithText>
                    <ImageContainer>
                        <HeroImage 
                            src="/open-brain.png" 
                            alt="Cerebro abierto con ideas filosóficas flotando"
                        />
                    </ImageContainer>
                    <VerticalText>Detalles sobre conocimiento inútil</VerticalText>
                    <TextContainer>
                        <BlogTitle>Blog de Filosofía</BlogTitle>
                    </TextContainer>
                </ImageWithText>
            </HeroImageContainer>
        </HeroContainer>
    )
}

export default HomeHero;
